import React, { useState, useEffect } from "react";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import PostAllDataModule from "../../../Components/Reuseable/PostAllDataModule";
import axios from "axios";
import Approved from "../../../assets/Icon/live.png";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const ApprovedPost = () => {
  const [event_data, setEvents] = useState([]);
  const [approved, setApproved] = useState("");

  const [buffer, setBuffer] = useState(true);

  //Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/simple_post/count`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setApproved(res.data.approved);
      }
    });
  }, []);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/simple_post/approved`).then((res) => {
      if (res.status === 200) {
        setEvents(res.data.post);
       
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live Post" image={Approved} count={approved} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <PostAllDataModule
          data={event_data}
          urlLink={`/superstar-admin/post/details`}
        />
      )}
    </>
  );
};

export default ApprovedPost;
